/* FleetPro Garage hub: active vehicle dossier, system-aware routing, and VIN/YMM capture. */
(function () {
  function init(root) {
    if (!root || root.dataset.fpghReady) return;
    if (!window.FPGarage) { setTimeout(function () { init(root); }, 60); return; }
    root.dataset.fpghReady = '1';
    var picker = root.querySelector('[data-fpgh-picker]');
    var engineSelect = root.querySelector('[data-fpgh-engine-select]');
    var TRUCK = root.dataset.truckFilter;
    var ENGINE = root.dataset.engineFilter;
    var CONFIRMED_FIT = { fit: 1, fit_engine: 1, engine_only: 1 };

    function vehicleLabel(t) { return (t && t.label) || [t && t.year, t && t.make, t && t.model].filter(Boolean).join(' ') || 'Your truck'; }
    function engineLabel(t) { return t && t.engine && (t.engine.parent || t.engine.other || t.engine.label) || root.dataset.engineEmpty; }
    function filterConfirmedProducts() {
      var active = window.FPGarage.getActive();
      Array.prototype.forEach.call(root.querySelectorAll('.fp-gh__product-grid'), function (grid) {
        var confirmed = 0;
        var visibleLimit = Number(grid.dataset.fpghVisibleLimit) || Infinity;
        Array.prototype.forEach.call(grid.children, function (card) {
          var badge = card.querySelector('[data-fp-cardfit]');
          var state = badge ? badge.dataset.fpState : '';
          var matched = !!(active && CONFIRMED_FIT[state]);
          var show = matched && confirmed < visibleLimit;
          card.hidden = !show;
          if (matched) confirmed++;
        });
        if (grid.classList.contains('fp-gh__product-grid--popular')) {
          var popular = grid.closest('.fp-gh__popular');
          if (popular) popular.hidden = confirmed === 0;
        } else {
          grid.hidden = confirmed === 0;
          var heading = grid.previousElementSibling;
          var pane = grid.closest('[data-resolver]');
          var empty = grid.nextElementSibling;
          if (heading && heading.classList.contains('fp-gh__system-products-head')) {
            heading.hidden = false;
            var title = heading.querySelector('[data-fpgh-products-title]');
            if (title) title.textContent = confirmed ? 'Verified fit picks' : 'Find the right part';
          }
          if (empty && empty.hasAttribute('data-fpgh-no-matches')) {
            empty.hidden = confirmed !== 0;
            var copy = empty.querySelector('[data-fpgh-no-matches-copy]');
            if (copy) copy.textContent = pane && pane.dataset.resolver === 'spec'
              ? 'VIN alone cannot confirm these parts. Browse the system, then match the component tag, size, or OEM number.'
              : 'No green-badge match is in this preview set. Browse every filtered result for this truck.';
          }
        }
      });
      root.dataset.fpghProductsReady = '1';
    }
    function withFitment(href, resolver) {
      var t = window.FPGarage.getActive();
      if (!t || resolver === 'spec') return href;
      var url = new URL(href, window.location.origin);
      if (resolver === 'engine' && t.engine && t.engine.parent) {
        url.searchParams.delete(TRUCK);
        url.searchParams.append(ENGINE, t.engine.parent);
        if (t.engine.child) url.searchParams.append(ENGINE, t.engine.child);
      } else if (resolver === 'truck' && t.value) {
        url.searchParams.delete(ENGINE);
        url.searchParams.append(TRUCK, t.value);
        url.searchParams.append(TRUCK, root.dataset.universal);
      }
      return url.pathname + url.search;
    }
    function renderVehicle() {
      var t = window.FPGarage.getActive();
      var heading = root.querySelector('[data-fpgh-heading]');
      heading.textContent = t
        ? root.dataset.headingTemplate.replace('__VEHICLE__', t.model || t.make || vehicleLabel(t))
        : root.dataset.headingDefault;
      root.querySelector('[data-fpgh-vehicle]').hidden = !t;
      root.querySelector('[data-fpgh-empty]').hidden = !!t;
      if (!t) return;
      root.querySelector('[data-fpgh-label]').textContent = vehicleLabel(t);
      root.querySelector('[data-fpgh-meta]').textContent = t.type === 'trailer'
        ? [t.body || root.dataset.trailerDefault, t.length ? t.length + ' ft' : ''].filter(Boolean).join(' · ')
        : [t.value, t.engine && (t.engine.child || t.engine.parent)].filter(Boolean).join(' · ');
      root.querySelector('[data-fpgh-engine]').textContent = engineLabel(t);
      engineSelect.value = t.engine && t.engine.parent || '';
      var vinBox = root.querySelector('[data-fpgh-vin-box]');
      vinBox.hidden = !t.vin;
      root.querySelector('[data-fpgh-vin]').textContent = t.vin || '';
      root.querySelector('[data-fpgh-vin-verified]').hidden = !t.vin;
      Array.prototype.forEach.call(root.querySelectorAll('[data-fpgh-fit-link]'), function (a) {
        if (!a.dataset.baseHref) a.dataset.baseHref = a.getAttribute('href');
        var pane = a.closest('[data-resolver]');
        a.href = withFitment(a.dataset.baseHref, pane ? pane.dataset.resolver : 'truck');
      });
    }
    function openPicker() { picker.open = true; document.documentElement.style.overflow = 'hidden'; }
    function closePicker() { picker.open = false; document.documentElement.style.overflow = ''; }
    Array.prototype.forEach.call(root.querySelectorAll('[data-fpgh-open-picker]'), function (b) { b.addEventListener('click', openPicker); });
    root.querySelector('[data-fpgh-close-picker]').addEventListener('click', closePicker);
    picker.addEventListener('click', function (e) { if (e.target === picker) closePicker(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && picker.open) closePicker(); });

    Array.prototype.forEach.call(root.querySelectorAll('[data-fpgh-dept]'), function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-fpgh-dept]').forEach(function (b) { var on = b === button; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
        root.querySelectorAll('[data-fpgh-panel]').forEach(function (p) { p.hidden = p.dataset.fpghPanel !== button.dataset.fpghDept; });
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fpgh-system]'), function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-fpgh-system]').forEach(function (b) { var on = b === button; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
        root.querySelectorAll('[data-fpgh-system-pane]').forEach(function (p) { p.hidden = p.dataset.fpghSystemPane !== button.dataset.fpghSystem; });
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fpgh-quick]'), function (button) {
      button.addEventListener('click', function () {
        var partsTab = root.querySelector('[data-fpgh-dept="parts"]');
        var systemButton = root.querySelector('[data-fpgh-system="' + button.dataset.fpghQuick + '"]');
        if (partsTab) partsTab.click();
        if (systemButton) systemButton.click();
        var browser = root.querySelector('.fp-gh__browse-head');
        if (browser) browser.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-fpgh-picker-tab]'), function (button) {
      button.addEventListener('click', function () {
        root.querySelectorAll('[data-fpgh-picker-tab]').forEach(function (b) { b.classList.toggle('is-active', b === button); });
        root.querySelectorAll('[data-fpgh-picker-pane]').forEach(function (p) { p.hidden = p.dataset.fpghPickerPane !== button.dataset.fpghPickerTab; });
      });
    });

    (window.FPGarage.engineParents || []).forEach(function (e) { engineSelect.appendChild(new Option(e, e)); });
    root.querySelector('[data-fpgh-engine-edit]').addEventListener('click', function () {
      engineSelect.hidden = false;
      engineSelect.focus();
    });
    engineSelect.addEventListener('change', function () { if (engineSelect.value) window.FPGarage.setActiveEngine(engineSelect.value); engineSelect.hidden = true; });

    var vinInput = root.querySelector('[data-fpgh-vin-input]');
    var vinStatus = root.querySelector('[data-fpgh-vin-status]');
    root.querySelector('[data-fpgh-vin-go]').addEventListener('click', function () {
      var vin = String(vinInput.value || '').toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
      vinInput.value = vin;
      vinStatus.className = '';
      if (vin.length !== 17) { vinStatus.textContent = root.dataset.msgVinIncomplete; vinStatus.className = 'is-error'; return; }
      if (!window.FPVIN) { vinStatus.textContent = root.dataset.msgVinLoading; return; }
      vinStatus.textContent = root.dataset.msgVinDecoding;
      window.FPVIN.load(root.dataset.vinMaps).then(function () { return window.FPVIN.fetchAndResolve(vin); }).then(function (res) {
        if (!res || !res.valid) throw new Error('invalid');
        if (res.kind === 'trailer') {
          var tr = res.trailer || {};
          window.FPGarage.add({ type: 'trailer', value: '', make: tr.make || '', model: 'trailer', year: tr.year || '', label: [tr.year, tr.make, 'trailer'].filter(Boolean).join(' '), body: tr.body || null, length: tr.length || null, vin: vin, source: 'vin' });
        } else if (res.truckKey) {
          window.FPGarage.add({ make: res.truck.make, model: res.truck.model, year: res.truck.year, value: res.truckKey, label: [res.truck.year, res.truck.make, res.truck.model].filter(Boolean).join(' '), engine: res.engine ? { parent: res.engine.parent || null, child: res.engine.child || null, era: res.engine.era || null, other: res.engine.other || null, label: res.engine.parent || res.engine.other || '' } : null, vin: vin, source: 'vin' });
        } else if (res.truck && (res.truck.make || res.truck.year)) {
          /* not in the picker vocab (e.g. Mack) — save an honest make-only
             truck: banner + AMT/engine badges follow it; truck axis stays
             silent (value:'' -> no gen key, no false truck-fit claims). */
          window.FPGarage.add({ make: res.truck.make || '', model: res.truck.model || '', year: res.truck.year || '', value: '', label: [res.truck.year, res.truck.make, res.truck.model].filter(Boolean).join(' ') || 'My truck', engine: res.engine ? { parent: res.engine.parent || null, child: res.engine.child || null, era: res.engine.era || null, other: res.engine.other || null, label: res.engine.parent || res.engine.other || '' } : null, vin: vin, source: 'vin' });
        } else {
          vinStatus.textContent = root.dataset.msgVinUnmapped; vinStatus.className = 'is-error'; return;
        }
        vinStatus.textContent = root.dataset.msgVinSaved; vinStatus.className = 'is-ok';
        setTimeout(closePicker, 650);
      }).catch(function () { vinStatus.textContent = root.dataset.msgVinFailed; vinStatus.className = 'is-error'; });
    });
    vinInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); root.querySelector('[data-fpgh-vin-go]').click(); } });

    root.querySelector('[data-fpgh-search]').addEventListener('submit', function (e) {
      var form = e.currentTarget;
      var query = String(form.querySelector('input[name="q"]').value || '').trim();
      if (!query) { e.preventDefault(); return; }
      if (form.dataset.oemChecked) return;
      var key = query.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
      if (key.length < 5 || !/\d/.test(key)) return;
      e.preventDefault();
      fetch(root.dataset.oemIndex).then(function (r) { return r.json(); }).then(function (index) {
        var hits = (index.entries || {})[key] || [];
        if (hits.length === 1 && index.products && index.products[hits[0]]) {
          window.location.href = '/products/' + index.products[hits[0]][0];
          return;
        }
        form.dataset.oemChecked = '1'; form.submit();
      }).catch(function () { form.dataset.oemChecked = '1'; form.submit(); });
    });
    document.addEventListener('fp:cards-rendered', filterConfirmedProducts);
    document.addEventListener('fp:garage-change', function () { renderVehicle(); filterConfirmedProducts(); if (picker.open && window.FPGarage.getActive()) closePicker(); });
    window.addEventListener('pageshow', renderVehicle);
    renderVehicle();
    filterConfirmedProducts();
    root.removeAttribute('data-fpgh-loading');
  }
  function boot() { document.querySelectorAll('[data-fp-garage-hub]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
